import { render, staticRenderFns } from "./ShortcutReviewMode.vue?vue&type=template&id=0b669d9c&scoped=true"
import script from "./ShortcutReviewMode.vue?vue&type=script&lang=js"
export * from "./ShortcutReviewMode.vue?vue&type=script&lang=js"
import style0 from "./ShortcutReviewMode.vue?vue&type=style&index=0&id=0b669d9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b669d9c",
  null
  
)

export default component.exports